<template>
  <div v-if="pixelTracking !== null">
    <div class="conversions-actions-parent">
      <vx-tooltip text="View Code" position="top">
        <vs-icon @click="viewCode()" class="conversions-view" icon="speakol-eye" icon-pack="speakol"></vs-icon>
      </vx-tooltip>

      <vx-tooltip text="Copy" position="top">
        <vs-icon @click="copyMainCode()" class="conversions-copy" icon="speakol-copy" icon-pack="speakol"></vs-icon>
      </vx-tooltip>
      <input class="hidden-input" id="conversionsMainCodeInput" type="text" :value="pixelTracking.main_code">


      <vx-tooltip text="Download" position="top">
        <vs-icon @click="saveMainCodeAsText()" class="conversions-download" icon="speakol-download" icon-pack="speakol">
        </vs-icon>
      </vx-tooltip>
    </div>

    <div v-show="showPixelCodePopup" class="converstions-show-code">
      <div class="overlay"></div>
      <div class="converstions-show-code-content">
        <h3 class="converstions-popup-title">Pixel Code</h3>
        <div class="conversions-popup-actions">
          <vx-tooltip text="Copy" position="top">
            <vs-icon @click="copyMainCode()" class="conversions-copy" icon="speakol-copy" icon-pack="speakol">
            </vs-icon>
          </vx-tooltip>

          <vx-tooltip text="Download" position="top">
            <vs-icon @click="saveMainCodeAsText()" class="conversions-download" icon="speakol-download"
              icon-pack="speakol"></vs-icon>
          </vx-tooltip>
        </div>
        <div class="code-area">
          <p>{{ pixelTracking.main_code }}</p>
        </div>

        <div class="conversions-popup-close">
          <button @click="closePixelCode()">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  data () {
    return {
      showPixelCodePopup: false
    }
  },
  computed: {
    ...mapGetters({
      pixelTracking: 'accounts/pixelTrackingDetails'
    })
  },
  methods: {
    showToaster (action) {
      this.$parent.$emit('show-toaster', action)
    },
    copyMainCode () {
      const copyText = document.getElementById('conversionsMainCodeInput')
      copyText.select()
      copyText.setSelectionRange(0, 99999)
      document.execCommand('copy')
      this.showToaster('copy')
      this.$gtag.event('Pixel_copycode')
    },
    saveTextAsFile (textToWrite, fileNameToSaveAs) {
      const textFileAsBlob = new Blob([textToWrite], {
        type: 'text/plain'
      })
      const downloadLink = document.createElement('a')
      downloadLink.download = fileNameToSaveAs
      downloadLink.innerHTML = 'Download File'
      if (window.webkitURL !== null) {
        downloadLink.href = window.webkitURL.createObjectURL(textFileAsBlob)
      } else {
        downloadLink.href = window.URL.createObjectURL(textFileAsBlob)
        downloadLink.style.display = 'none'
        document.body.appendChild(downloadLink)
      }
      downloadLink.click()
    },
    closePixelCode () {
      this.showPixelCodePopup = false
    },
    viewCode () {
      this.showPixelCodePopup = true
      this.$gtag.event('Pixel_viewcode')
    },
    saveMainCodeAsText () {
      this.$gtag.event('Pixel_downloadcode')
      this.saveTextAsFile(this.pixelTracking.main_code, 'installation_code.txt')
      this.showToaster('download')
    }
  }
}
</script>

<style lang="scss" scoped>
  .conversions-actions-parent {
    display: flex;
  }

  .conversions-actions {
    .conversions-view {
      color: #0092d7;
      background: rgba(0, 146, 215, 0.16551);
      padding: 10px;
      border-radius: 100%;
      cursor: pointer;
      font-size: 20px !important;
    }

    .conversions-download {
      color: #0092d7;
      background: rgba(0, 146, 215, 0.16551);
      padding: 10px;
      border-radius: 100%;
      cursor: pointer;
      font-size: 20px !important;
    }

    .conversions-copy {
      color: #0092d7;
      margin-left: 16px;
      margin-right: 16px;
      padding: 10px;
      background: rgba(0, 146, 215, 0.16551);
      border-radius: 100%;
      cursor: pointer;
      font-size: 20px !important;
    }

    .hidden-input {
      opacity: 0;
      top: 0;
      position: absolute;
    }
  }

  .converstions-show-code {
    .overlay {
      z-index: 99991 !important;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.27);
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
    }

    .converstions-show-code-content {
      z-index: 99992 !important;
      position: fixed;
      width: 634px;
      padding: 48px;
      left: 50%;
      top: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      background: #fff;
      box-shadow: 0 4px 30px rgba(91, 111, 121, 0.25);
      border-radius: 20px;

      .converstions-popup-title {
        font-weight: 500;
        font-size: 24px;
        color: #2c2c2c;
        float: left;
      }

      .conversions-popup-actions {
        float: right;
        display: flex;
        margin-bottom: 16px;
      }

      .conversions-download {
        color: #0092d7;
        background: rgba(0, 146, 215, 0.16551);
        padding: 10px;
        font-size: 20px !important;
        border-radius: 100%;
        cursor: pointer;

        i {
          display: none;
        }
      }

      .conversions-copy {
        color: #0092d7;
        padding: 10px;
        font-size: 20px !important;
        background: rgba(0, 146, 215, 0.16551);
        border-radius: 100%;
        cursor: pointer;
        margin-right: 16px;
      }

      .code-area {
        border: 1px solid #c2c2c2;
        padding: 20px;
        width: 100%;
        border-radius: 8px;
        display: flex;

        p {
          color: #575757;
        }
      }

      .conversions-popup-close {
        margin-top: 32px;
        text-align: right;

        button {
          background: #0092d7;
          border-radius: 3px;
          color: white;
          font-weight: 500;
          font-size: 14px;
          padding: 16px 75px;
          outline: none;
          box-shadow: none;
          border: none;
          cursor: pointer;
        }
      }
    }
  }

  @media (max-width: 768px) {
    .converstions-show-code-content {
      width: 90% !important;
      padding: 24px !important;

      h3 {
        font-size: 18px !important;
        position: relative;
        top: 10px;
      }

      .conversions-popup-close {
        button {
          width: 100%;
        }
      }

      .code-area {
        width: 100%;
        overflow-x: auto;
      }
    }
  }

</style>
